module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Success-0631371e70a919751265788dc6f5bd7e.svg";